import { useState, useEffect } from 'react'

// Hook di supporto per adattare i layout costruiti con style inline (niente
// CSS module/Tailwind in questo progetto, vedi index.css) sotto una certa
// larghezza di finestra. Non usa matchMedia per restare semplice: basta un
// listener su resize, ricalcolato solo quando si attraversa la soglia.
//
// Uso tipico: `const isMobile = useIsMobile()` e poi si sceglie a mano, nel
// JSX, tra il layout "desktop" (tabelle a griglia, pannelli affiancati) e
// quello impilato/a-card per schermi stretti.
export default function useIsMobile(breakpoint = 860) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= breakpoint
  )

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint)
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}
